import { Navigate, useSearchParams } from "react-router-dom";

import { SetupSecurityScreen } from "../components/auth/SetupSecurityScreen";
import { PREVIEW_INITIAL_ENROLLMENT } from "../lib/auth/setup-security-preview";
import { IS_PREVIEW } from "../lib/pro-mode";

/**
 * DEV fixture route `/preview/setup-security?trigger=acquisition|has_clients
 * &step=totp|passkey&state=qr`. Renders only under IS_PREVIEW (no Clerk key
 * AND a Vite dev build); anywhere else it redirects away. Never touches a
 * real user: the panel and passkey hook serve local fixtures in preview.
 */
export function SetupSecurityPreviewPage() {
  const [params] = useSearchParams();
  if (!IS_PREVIEW) return <Navigate to="/" replace />;
  const trigger =
    params.get("trigger") === "has_clients" ? "has_clients" : "acquisition";
  const step = params.get("step") === "passkey" ? "passkey" : "totp";
  return (
    <SetupSecurityScreen
      trigger={trigger}
      initialStep={step}
      preview
      initialEnrollment={
        params.get("state") === "qr" ? PREVIEW_INITIAL_ENROLLMENT : undefined
      }
      onNotNow={trigger === "acquisition" ? () => undefined : undefined}
      onComplete={() => undefined}
    />
  );
}
